import { render, staticRenderFns } from "./OrgIndex.vue?vue&type=template&id=087124d4&scoped=true"
import script from "./OrgIndex.vue?vue&type=script&lang=js"
export * from "./OrgIndex.vue?vue&type=script&lang=js"
import style0 from "./OrgIndex.vue?vue&type=style&index=0&id=087124d4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087124d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('087124d4')) {
      api.createRecord('087124d4', component.options)
    } else {
      api.reload('087124d4', component.options)
    }
    module.hot.accept("./OrgIndex.vue?vue&type=template&id=087124d4&scoped=true", function () {
      api.rerender('087124d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/org/OrgIndex.vue"
export default component.exports